import clsx from "clsx";
import { Button } from "components/common/Button";
import { Tooltip } from "components/common/Tooltip";
import { ICONS } from "./constants";
import type { UndoRedoButtonProps } from "./types";

export const UndoRedoButton = ({ action, icon }: UndoRedoButtonProps) => {
  const Icon = ICONS[icon];

  return (
    <Tooltip label={action.label}>
      <Button
        variant="text"
        size="sm"
        aria-label={action.label}
        disabled={!action.isAvailable}
        // A disabled button swallows hover, so the tooltip wrapper must receive it instead.
        className={clsx(
          "!px-1.5",
          !action.isAvailable && "pointer-events-none",
        )}
        onClick={action.run}
      >
        <Icon size={18} />
      </Button>
    </Tooltip>
  );
};
